<template>
    <div class="the-header fill-height d-flex align-center">
        <v-btn class="d-lg-none" color="#fff" icon large @click.stop="drawerToggle">
            <v-icon center>mdi-menu</v-icon>
        </v-btn>
        <div class="the-header__logo" :class="{'logo--centered': $vuetify.breakpoint.mdAndDown}">
            <router-link :to="{name: 'clients.list'}">
                <img src="../assets/r-logo-light.svg" alt="RClient" v-if="$vuetify.breakpoint.smAndUp">
                <img src="../assets/r-logo.svg" alt="R" v-if="$vuetify.breakpoint.xsOnly">
            </router-link>
        </div>
        <v-spacer></v-spacer>
        <v-btn :to="{name: 'settings'}"
               class="mx-4"
               dark
               :color="$vuetify.breakpoint.mdAndDown ? '#fff' : 'primary'"
               depressed
               rounded
               large
               :icon="$vuetify.breakpoint.mdAndDown"
               :class="{'pl-1': $vuetify.breakpoint.lgAndUp}"
        >
            <v-avatar size="36">
                <img v-if="$auth.user().avatar" :src="$auth.user().avatar.url">
                <v-icon v-else>mdi-account-circle</v-icon>
            </v-avatar>
            <span class="d-none d-lg-block ml-2">{{ $auth.user().name }}</span>
        </v-btn>
        <v-btn color="#fff" icon large @click="logout">
            <v-icon center>mdi-logout</v-icon>
        </v-btn>
    </div>
</template>

<script>
    export default {
        name   : "TheHeader",
        props: {
            value: {
                type: Boolean
            }
        },
        methods: {
            logout() {
                this.$auth.logout();
            },
            drawerToggle() {
                this.$emit('input', !this.value);
            }
        }
    }
</script>

<style lang="scss">
    .the-header {
        position: relative;
        width: 100%;

        .the-header__logo {

            &.logo--centered {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            a {
                display: flex;
                align-items: center;
                justify-content: center;
                text-decoration: none;
                user-select: none;
            }

            img {
                display: block;
                height: 40px;
                
                .viewport-sm &,
                .viewport-xs & {
                    height: 36px;
                }
            }
        }
    }
</style>
